<template>
    <div class="row mt-3">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header px-3 py-2 bg-primary">
                    {{ checklist_item.no_cmt }} {{ $t('comment.comment') }}
                    <div class="card-actions mr-3 mt-2" style="cursor: pointer;" @click="closeComment()">
                        <span> <i class="fa fa-times"></i> {{ $t('comment.close') }}</span>
                    </div>
                </div>
                <div v-if="!comments" class="text-center">
                    loading ...
                </div>
                <div v-else class="card-body p-1">
                    <div class="mb-3" v-if="checklist_item.checklist_item_status.is_report">
                        <form>
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label">{{ $t('checklist_fix.expiration_date')
                                    }}:</label>
                                <div class="col-sm-3">
                                    <input type="date" :disabled="checklist.status.code !== 3" class="form-control"
                                        v-model="checklist_item.corrective_date" @blur="handleBlur()">
                                </div>
                                <label class="col-sm-2 col-form-label"
                                    v-chkpermission="$permissions.SET_CORRECTIVE_STATUS">{{ $t('checklist_fix.status')
                                    }}:</label>
                                <div class="col-sm-3" v-chkpermission="$permissions.SET_CORRECTIVE_STATUS">
                                    <select name="" id="" class="form-control"
                                        v-model="checklist_item.corrective_status" @change="changeCorrectiveStatus()">
                                        <option value="0">{{ $t('checklist_fix.incomplete') }}</option>
                                        <option value="1">{{ $t('checklist_fix.complete') }}</option>
                                    </select>
                                </div>

                            </div>
                        </form>
                        <div>
                            <div v-for="(item, index) in checklist_item.cmt_crv" :key="index">
                                <span style="color:#000000;font-weight: 500;">[{{ item.created_at }}]</span><br>
                                <span style="color:#FF8000" v-html="item.content"></span>
                                <div class="row col-md-12">
                                    <div class="" style="text-align: center;" v-for="(img, index) in item.images"
                                        :key="index">
                                        <a :href="img" target="_blank">
                                            <img v-if="item.images_resize[index] !== ''"
                                                :src="item.images_resize[index]" class="img-fluid img-thumbnail m-2"
                                                width="70">
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                    </div>
                    <b-media v-for="(comment, index) in comments" :key="index">
                        <b-img class="avatar-cmt" slot="aside" :src="comment.user ? comment.user.avatar500x500 : ''"
                            height="50" width="50" />
                        <a href="#" style="font-weight: 600">{{ comment.user ? comment.user.fullname : '' }}
                            [{{ comment.user ? comment.user.email : '' }}]</a>
                        <span :class="{ tick: !comment.is_final, check: comment.is_final, }" @click="setFinal(comment)"
                            data-toggle="tooltip" data-placement="top" :title="$t('notification.chk_item_cmt_final')"><i
                                class="fa fa-check"></i></span>
                        <b-dropdown class="float-right" variant="transparent p-0" right
                            v-if="comment.user && comment.user.id === profile.id">
                            <template slot="button-content">
                                <span class="link"><i class="fa fa-cog"></i> {{ $t('checklist.attribute.action')
                                    }}</span>
                            </template>
                            <b-dropdown-item @click="update(comment)">
                                <i class="fa fa-pencil"></i>{{ $t('comment.update') }}</b-dropdown-item>
                            <b-dropdown-item @click="destroy(comment)">
                                <i class="fa fa-trash"></i>{{ $t('comment.delete') }}</b-dropdown-item>
                        </b-dropdown>
                        <h6 class="small text-muted"><i class="fa fa-clock-o"></i> {{ comment.time }}</h6>
                        <span v-html="comment.content"></span>
                        <div class="row col-md-12">
                            <div v-for="(image, index) in comment.images" :key="index">
                                <a v-if="comment.images[index] !== ''" :href="comment.images[index]" target="_blank">
                                    <img v-if="comment.images_resize[index] !== ''" :src="comment.images_resize[index]"
                                        class="img-fluid img-thumbnail m-2" width="100">
                                </a>
                            </div>
                        </div>
                        <span class="link small" @click="showReply(index)"><i class="fa fa-reply"></i>
                            {{ comment.children ? comment.children.length : 0 }}
                            {{ $t('comment.reply') }}</span>
                        <child-comment class="mt-2" v-if="index === child_comment" :comments="comments"
                            :comment="comment" :child_comments="comment.children"
                            :checklist_item="checklist_item"></child-comment>
                        <hr v-if="index + 1 < comments.length" class="mt-1 mb-1">
                    </b-media>
                    <b-media v-if="checkcomment()" class="mt-3">
                        <b-img class="avatar-cmt" slot="aside" :src="profile.avatar500x500" width="50" height="50" />
                        <span class="link" @click="addissue"> {{ $t('comment.add_issue') }}</span>
                        <textarea v-if="issue" :placeholder="$t('comment.write_issue')" class="col-md-12 form-control"
                            rows="3" v-model="cmt.issue"></textarea>
                        <br />
                        <textarea :placeholder="$t('comment.write_comment')" class="col-md-12 form-control textarea"
                            rows="3" v-model="cmt.result" @paste="handlePaste"></textarea>
                        <error :error="errors.content"></error>

                        <div class="col-md-12">
                            <div class="mt-2 mr-2" v-for="(item, index) in cmt.attach" :key="index">
                                <i class="fa fa-paperclip" aria-hidden="true"></i>
                                <span v-html="item"></span>
                                <i class="fa fa-minus ml-2 pointer" aria-hidden="true" style="color:red"
                                    @click="removeFile(index)"></i>
                            </div>
                        </div>

                        <div class="row col-md-12">
                            <div class="mt-3 mr-3" style="text-align: center;" v-for="(img, index) in preview"
                                :key="index">
                                <b-img :src="img" height="64" width="64" />
                                <h6 class="text-center link" @click="remove(index)"><i class="fa fa-trash"></i>
                                    {{ $t('comment.remove') }}
                                </h6>
                                <error :error="errors['images.' + index]"></error>
                            </div>
                        </div>

                        <span class="link" @click="openUploadImage"><i class="fa fa-picture-o"></i> {{
                        $t('comment.add_image') }}</span>
                        <span class="link" @click="openUploadFile"><i class="fa fa-cloud-upload"></i> {{
                        $t('comment.add_file') }}</span>
                        <input type="file" class="form-control hidden" ref="uploadImage" :multiple="true"
                            accept="image/*" @change="change">
                        <input type="file" class="form-control hidden" ref="uploadFile" :multiple="false" accept="*"
                            @change="uploadFile">
                        <error :error="errors.file"></error>
                        <div class="pull-right mt-2">
                            <button class="btn btn-sm btn-primary" @click="comment()" :disabled="btn_submit"><i
                                    class="fa fa-paper-plane"></i> {{ $t('comment.comment') }}</button>
                        </div>
                    </b-media>
                </div>
                <div class="card-footer text-right" v-if="!checkcomment()">
                    <i class="fa fa-warning"></i> {{ $t('comment.noncomment') }}
                </div>
            </div>
        </div>
        <EditComment ref="edit_comment" @updateSuccess="updateSuccess"/>
    </div>
</template>
<script>
import swal from 'sweetalert'
import lodash from 'lodash'
import ChildComment from './child-comment'
import { mapGetters } from 'vuex'
import EditComment from './edit-comment.vue'

export default {
  name: 'comment',
  components: { ChildComment, EditComment },
  props: ['checklist_item', 'comments'],
  data () {
    return {
      cmt: {
        content: '',
        issue: '',
        result: '',
        attach: []
      },
      errors: {},
      files: [],
      preview: [],
      btn_submit: false,
      issue: false,
      child_comment: false,
      checklistId: this.$route.params.checklist_id
    }
  },
  computed: {
    ...mapGetters({
      profile: 'Profile/getProfile'
    }),
    checklist () {
      return this.$store.getters['Checklist/showChecklist']
    }
  },
  mounted () {

  },
  methods: {
    handlePaste (event) {
      const items = (event.clipboardData || event.originalEvent.clipboardData).items
      for (let item of items) {
        if (item.kind === 'file' && item.type.startsWith('image/')) {
          const file = item.getAsFile()
          this.files.push(file)
          const reader = new FileReader()
          reader.onload = (e) => {
            this.preview.push(e.target.result)
          }
          reader.readAsDataURL(file)
        }
      }
    },
    openUploadImage () {
      this.$refs.uploadImage.click()
    },
    openUploadFile () {
      this.$refs.uploadFile.click()
    },
    addissue () {
      this.issue = !this.issue
    },
    // comment
    comment () {
      this.btn_submit = true
      const data = new FormData()
      let content = this.cmt.result
      if (this.issue && (this.cmt.issue !== '' || this.cmt.result !== '')) {
        content = this.$t('comment.issue') + ': ' + this.cmt.issue + '<br/>' + this.$t('comment.result') + ': ' + this.cmt.result
      }
      let attach = this.cmt.attach.length > 0 ? '<br/>' + this.cmt.attach : ''

      data.append('content', content + attach)
      data.append('parent_id', 0)
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i]
        data.append('images[' + i + ']', file)
      }

      this.$store.dispatch('Comment/createCommentOfChecklistItem', { checklist: { id: this.checklistId }, checklist_item: this.checklist_item, comment: data }).then(res => {
        res.children = []
        this.comments.push(res)
        this.cmt = {
          content: '',
          issue: '',
          result: '',
          attach: []
        }
        this.files = []
        this.preview = []
        this.errors = {}
        this.issue = false
        this.checklist_item.no_cmt += 1
        this.btn_submit = false
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.btn_submit = false
      })
    },

    // event upload image
    change (event) {
      console.log(event)
      for (var i = 0; i < this.$refs.uploadImage.files.length; i++) {
        this.files.push(this.$refs.uploadImage.files[i])
        let reader = new FileReader()
        reader.onload = (event) => {
          this.preview.push(event.target.result)
        }
        reader.readAsDataURL(this.$refs.uploadImage.files[i])
      }
    },

    // event upload file
    uploadFile (event) {
      const fd = new FormData()
      fd.append('file', this.$refs.uploadFile.files[0])
      fd.append('type', 'file')
      this.$store.dispatch('Comment/attachFileInComment', { file: fd }).then(res => {
        this.cmt.attach.push('<a target="_blank" href=https://docs.google.com/viewerng/viewer?url=' + res + '>' + this.$refs.uploadFile.files[0].name + '</a>')
        this.open_upload_file = !this.open_upload_file
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
          this.open_upload_file = !this.open_upload_file
        }
      })
    },

    // remove file attach
    removeFile (index) {
      this.cmt.attach.splice(index, 1)
    },

    // remove preview image
    remove (index) {
      this.files.splice(index, 1)
      this.preview.splice(index, 1)
      delete this.errors['images.' + index]
    },
    destroy (comment) {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
            this.$store.dispatch('Comment/destroyCommentOfChecklistItem', {
              checklist: { id: this.checklistId }, checklist_item: this.checklist_item, comment
            }).then((res) => {
              var index = lodash.findIndex(this.comments, ['id', comment.id])
              this.comments.splice(index, 1)
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
              this.checklist_item.no_cmt -= 1
            }).catch(errors => {

            })
          }
        })
    },
    closeComment () {
      this.$store.commit('Audit/closeCommentOfChecklistItem', this.checklist_item)
    },
    update (comment) {
      this.$refs.edit_comment.showModel(this.checklist_item, comment)
    },
    setFinal (comment) {
      if (comment.is_final) {
        return false
      }

      this.$store.dispatch('Comment/setCommentIsFinal', { comment }).then(res => {
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
        this.comments.forEach(element => {
          element.is_final = false
        })
        comment.is_final = true
        var index = lodash.findIndex(this.comments, ['id', comment.id])
        this.comments.splice(index, 1, comment)
        this.checklist_item.comments = this.comments
        this.$store.commit('Audit/addCommentToChecklistItem', this.checklist_item)
      }).catch(errors => {

      })
    },
    updateSuccess (comment) {
      var index = lodash.findIndex(this.comments, ['id', comment.id])
      comment.children = this.comments[index].children
      this.comments.splice(index, 1, comment)
      this.checklist_item.comments = this.comments
      this.$store.commit('Audit/addCommentToChecklistItem', this.checklist_item)
    },
    checkcomment () {
      if (parseInt(this.checklist_item.checklist_item_status.is_cmt)) {
        return true
      } else {
        return false
      }
    },
    handleBlur () {
      this.$store.dispatch('Audit/setCorrectiveDate', { checklist: { id: this.checklistId }, checklist_item: this.checklist_item }).then(res => {

      }).catch(errors => {

      })
    },
    changeCorrectiveStatus () {
      this.$store.dispatch('Audit/setCorrectiveStatus', { checklist: { id: this.checklistId }, checklist_item: this.checklist_item }).then(res => {

      }).catch(errors => {

      })
    },
    // show reply comment
    showReply (index) {
      this.child_comment = index
      console.log(this.child_comment)
    }

  }
}
</script>
<style lang="scss">
.tick {
    color: #ddd;
    cursor: pointer;
    font-size: 20px
}

.tick:hover {
    color: rgb(32, 168, 216)
}

.check {
    color: rgb(32, 168, 216);
    font-size: 20px
}

.pointer {
    cursor: pointer;
}

.avatar-cmt {
    border-radius: 50%;
    box-shadow: 0px 2px 2px #a9a9a9;
}

.hidden {
    display: none!important;
}
</style>



// WEBPACK FOOTER //
// src/views/checklist/view/checklist-item/comment/index.vue